export const getSupply = (poster: any) => {
  if (poster) return `${parseInt(poster.trade[0]) - parseInt(poster.trade[1])} / ${poster.trade[0]}`;
  else return `-- / --`;
};
